import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { GuestProvider } from "@/contexts/GuestContext";
import Layout from "@/components/layout/Layout";
import LanguageLanding from "@/pages/LanguageLanding";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Schedule from "@/pages/Schedule";
import Travel from "@/pages/Travel";
import Rsvp from "@/pages/Rsvp";
import Gallery from "@/pages/Gallery";
import Upload from "@/pages/Upload";
import Faq from "@/pages/Faq";
import Guestbook from "@/pages/Guestbook";
import Gifts, { GiftsThanks } from "@/pages/Gifts";
import Dj from "@/pages/Dj";
import Admin from "@/pages/Admin";
import { ensureServiceWorker } from "@/lib/push";
import { initInstallCapture } from "@/lib/install";

function App() {
  React.useEffect(() => {
    // Register the PWA service worker as soon as the app mounts.
    ensureServiceWorker().catch(() => {});
    // Capture the beforeinstallprompt event so we can drive an in-app install CTA.
    initInstallCapture();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <GuestProvider>
            <Routes>
              <Route path="/" element={<LanguageLanding />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/:lang" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="story" element={<Story />} />
                <Route path="schedule" element={<Schedule />} />
                <Route path="travel" element={<Travel />} />
                <Route path="rsvp" element={<Rsvp />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="upload" element={<Upload />} />
                <Route path="guestbook" element={<Guestbook />} />
                <Route path="gifts" element={<Gifts />} />
                <Route path="gifts/thanks" element={<GiftsThanks />} />
                <Route path="dj" element={<Dj />} />
                <Route path="faq" element={<Faq />} />
              </Route>
            </Routes>
          </GuestProvider>
        </AuthProvider>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
